import { Platform } from '@ionic/angular';
import { AppComponent } from 'src/app/app.component';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  URL: "https://backend.efectivodigital.com.ar/",
  URL_LOGIN: "https://backend.efectivodigital.com.ar/",
  ACTIVAR_TEST: true,
  
  mobile:false,
  onlyWeb :true,
  get_url: () =>{
    return environment.URL
  },
  get_url_login: () =>{
      return environment.URL_LOGIN
  }
  // URL_LOGIN: "http://172.17.0.1:360/"
  // ionic cordova run browser --livereload  --consolelogs --serverlogs
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
